<template>
  <t-space>
    <t-sticky-tool :style="{ position: 'relative', overflow: 'hidden' }" :offset="[-50, 0]" type="compact">
      <t-sticky-item
        label="联系方式"
        :icon="renderCallIcon"
        :popup="renderPopupCall"
        :popup-props="{ overlayInnerStyle: { padding: '8px 16px' } }"
      >
      </t-sticky-item>
      <t-sticky-item
        label="二维码"
        :icon="renderQrIcon"
        :popup="renderPopupQrCode"
        :popup-props="{ overlayInnerStyle: { padding: '4px', height: '128px' } }"
      >
      </t-sticky-item>
    </t-sticky-tool>
  </t-space>
</template>

<script setup lang="jsx">
import { Call1Icon, QrcodeIcon } from 'tdesign-icons-vue-next';
import { onMounted, ref } from 'vue';

import { customerService } from '@/api/dashboard/base';

const apiUrl = `${import.meta.env.VITE_API_URL}/`;

// 客服信息
const customerServiceData = ref({
  customerServicePhone: '',
  customerServiceQrCode: '',
});

onMounted(async () => {
  await getCustomerService();
});

// 获取客服信息
const getCustomerService = async () => {
  const { data } = await customerService();
  customerServiceData.value = data;
};

// 联系方式
const renderCallIcon = () => {
  return <Call1Icon />;
};
const renderPopupCall = () => {
  return (
    <t-space direction="vertical" align="center" size="small">
      <p>客服电话</p>
      <t-link theme="primary" hover="color">
        {customerServiceData.value.customerServicePhone}
      </t-link>
    </t-space>
  );
};

// 二维码
const renderQrIcon = () => {
  return <QrcodeIcon />;
};
const renderPopupQrCode = () => {
  return (
    <t-image src={`${apiUrl}${customerServiceData.value.customerServiceQrCode}`} style="width: 120px; height: 120px" />
  );
};
</script>

<style lang="less" scoped></style>
